import {createMachine} from 'xstate'
import type {UserFollowButtonFollowMutation$data} from './__generated__/UserFollowButtonFollowMutation.graphql'
import type {UserFollowButtonUnfollowMutation$data} from './__generated__/UserFollowButtonUnfollowMutation.graphql'

export const userFollowButtonMachine = createMachine(
  {
    id: 'userFollowButton',
    initial: 'idle',
    schema: {
      context: {} as {},
      events: {} as
        | {
            type: 'FOLLOW_USER'
            id: string
          }
        | {
            type: 'UNFOLLOW_USER'
            id: string
          },
      services: {} as {
        followUser: {
          data: UserFollowButtonFollowMutation$data
        }
        unfollowUser: {
          data: UserFollowButtonUnfollowMutation$data
        }
      },
    },
    tsTypes: {} as import('./userFollowButtonMachine.typegen').Typegen0,
    states: {
      idle: {
        on: {
          FOLLOW_USER: 'following',
          UNFOLLOW_USER: 'unfollowing',
        },
      },

      following: {
        invoke: {
          id: 'followUser',
          src: 'followUser',
          onDone: 'idle',
          onError: {
            actions: 'setErrorMessage',
            target: 'idle',
          },
        },
      },

      unfollowing: {
        invoke: {
          id: 'unfollowUser',
          src: 'unfollowUser',
          onDone: 'idle',
          onError: {
            actions: 'setErrorMessage',
            target: 'idle',
          },
        },
      },
    },
  },
  {
    actions: {
      setErrorMessage: () => {
        console.log('setErrorMessage: ')
      },
    },
  }
)
